import { StatusState } from '../models/enum/statusState';

export class StatusHelper {

  public static getStatusClass(currentStatus: string): string {
    for (const value of Object.values(StatusState)) {
      if (currentStatus === value) {
        return Object.keys(StatusState)[Object.values(StatusState).indexOf(value)].toLowerCase();
      }
    }
  }

  public static getStatusStates(): string[] {
    return Object.values(StatusState);
  }
}
